<template>
<!-- use message to display dataCheckErrors -->
    <div>
        <div class="columns is-mobile">
            <div class="column">
                <p class="title has-text-left">Upload Experimental Dataset</p> 
            </div>
        </div>     

        <div class="tile is-ancestor">
            <div class="tile has-text-left is-12 is-vertical is-parent">
                <div class="tile is-child box">
                    <div class="columns is-mobile">
                        <div class="column is-one-quarter"><strong>Dataset Name:</strong></div>
                        <div class="column">{{currentExperimentalDataset.name}}</div>
                    </div>

                    <div class="columns is-mobile">
                        <div class="column is-one-quarter"><strong>Status:</strong></div>
                        <div class="column">{{currentExperimentalDataset.status}}</div>
                    </div>

                    <div class="columns is-mobile">
                        <div class="column is-one-quarter"><strong>Experimental Plan:</strong></div>
                        <div class="column">{{currentExperimentalPlan.name}}</div>
                    </div>                    
                </div>
                
                <!-- Validation Parameters Start -->
                <div class="tile is-child">
                    <p class="subtitle is-4">Validation Parameters</p>

                    <div v-for="valParam in valParamSet" :key="valParam">
                        <a class="button accordionButton is-large is-fullwidth" style="margin-top:20px" :id="valParam" v-on:click="accordionAction(valParam)">
                            <span>
                                {{valParam}}
                            </span>
                            <span class="icon is-small is-pulled-right">
                                <i class="fas fa-caret-down"></i>
                            </span>
                        </a>
                        <div class="tile is-ancestor contentOfAccordion">
                            <div class="tile is-parent">
                                <div class="tile is-child box">
                                    <div class="content">
                                        <!-- Heading of Validation Parameter -->
                                        <div class="columns is-mobile">
                                            <div class="column">
                                                <strong>Method of Assessment</strong>
                                            </div>
                                        </div>
                                        <!-- /Heading of Validation Parameter -->

                                        <!-- content of Validation Parameter -->
                                        <div v-for="assesmentMethod in assesmentMethods" :key="assesmentMethod.id"  v-if="assesmentMethod.validation_parameter_display == valParam">
                                            <hr>
                                            <div class="columns is-mobile" >
                                                <div class="column">
                                                    {{assesmentMethod.name}}
                                                </div>

                                                <div class="column">
                                                    <a v-bind:href="assesmentMethod.input_template" download class="button is-small">
                                                        <span class="icon is-small">
                                                            <i class="fas fa-download"></i>
                                                        </span>
                                                        <span>Download Template</span>
                                                    </a>
                                                </div>

                                                <div class="column" v-if="assesmentMethod.name.toUpperCase().includes('UPLOAD')">
                                                    <b-field>
                                                        <b-select v-model="analyteSelections[assesmentMethod.name]" size="is-small" expanded placeholder="Select an analyte">
                                                            <option value="NA">
                                                                Not Applicable
                                                            </option>
                                                            <option
                                                                v-for="analyte in currentMethod.analytes"
                                                                :value="analyte"
                                                                :key="analyte.id">
                                                                {{analyte.short_name.toUpperCase()}} ({{ analyte.abbreviation }})
                                                            </option>
                                                        </b-select>
                                                    </b-field>

                                                    <!-- analyte upload -->
                                                    <section> 
                                                        <b-field>
                                                            <b-upload v-model="dropFilesObject[assesmentMethod.name]" :ref="assesmentMethod.name" multiple drag-drop>
                                                                <section class="section">
                                                                    <div class="content has-text-centered">
                                                                        <p>
                                                                            <b-icon icon="upload" pack="fas" size="is-large">
                                                                            </b-icon>
                                                                        </p>
                                                                        <p>Drop your files here or click to upload</p>
                                                                    </div>
                                                                </section>
                                                            </b-upload>
                                                        </b-field>

                                                        <div class="tags">
                                                            <span v-for="(file, index) in dropFilesObject[assesmentMethod.name]" :key="index" class="tag is-primary" >
                                                                {{file.name}}
                                                                <button class="delete is-small"
                                                                    type="button"
                                                                    @click="deleteDropFile(index, assesmentMethod.name)">
                                                                </button>
                                                            </span>
                                                        </div>
                                                    </section>
                                                    <!-- analyte upload end -->
                                                </div>
                                                <div class="column" v-else>
                                                    <b-field class="file is-small">
                                                        <b-upload v-model="singlefiles[assesmentMethod.name]" accept=".csv">
                                                            <a class="button is-small">
                                                                <b-icon icon="upload" pack="fas"></b-icon>
                                                                <span>Click to upload</span>
                                                            </a>
                                                        </b-upload>
                                                        <span class="file-name" v-if="singlefiles[assesmentMethod.name]">
                                                            {{ singlefiles[assesmentMethod.name].name }}
                                                        </span>
                                                    </b-field>
                                                                                                        
                                                    <div style="margin-top:10px" v-if="singlefiles[assesmentMethod.name] && !singlefiles[assesmentMethod.name].type.includes('excel')&& !singlefiles[assesmentMethod.name].type.includes('csv')">
                                                        <b-message type="is-danger">
                                                            Incorrect format of file. Select the correct format of file. {{singlefiles[assesmentMethod.name].type}}
                                                        </b-message>
                                                    </div>
                                                </div>
                                                <div class="column">
                                                    <a v-if="assesmentMethod.name.toUpperCase().includes('UPLOAD')" class="button is-primary is-small" @click="saveChromatogram(assesmentMethod)">
                                                        <span>Upload</span>
                                                    </a>
                                                    <a v-else class="button is-primary is-small" @click="saveFile(assesmentMethod)">
                                                        <span>Upload</span>
                                                    </a>
                                                </div>
                                            </div>
                                            <hr>
                                        </div>
                                        <!-- /content of Validation Parameter -->
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <!-- Validation Parameters end -->

                <div class="tile is-child">
                    <!-- Action buttons -->
                    <span class="is-pulled-right">
                        <a class="button is-large" @click="$router.go(-1)">
                            <span>Back</span>
                        </a>
                    </span>
                </div> 
            </div>
        </div>        
    </div>
    
</template>


<script>
export default {
    name: "UploadExperimentalDatasetComponent",    
    props: ["currentValidationPlanTemplate", "assesmentMethods", "currentExperimentalPlan", "currentExperimentalDataset", "currentMethod", "validationParameters"],
    data: function() {

        return {
            filesAndAssesmentMethodsobject: {},
            selectedAnalyte:{},
            dropFiles: [],
            dropFilesObject: {},
            analyteSelections:{},
            singlefiles:{}
        }
    },
    mounted: function(){
        var mainThis=this
        if(Object.keys(this.dropFilesObject).length==0){                
            this.assesmentMethods.forEach(function(assesmentMethod){
                mainThis.dropFilesObject[assesmentMethod.name] = null
            })
        }

        if(Object.keys(this.analyteSelections).length==0){
            this.assesmentMethods.forEach(function(assesmentMethod){
                mainThis.analyteSelections[assesmentMethod.name] = null
            })
        }

        if(Object.keys(this.singlefiles).length==0){
            this.assesmentMethods.forEach(function(assesmentMethod){
                mainThis.singlefiles[assesmentMethod.name] = null
            })
        }
    },
    computed: {
        valParamSet: function(){   
            var valParamSet = new Set()    
            this.assesmentMethods.forEach(function(method) {            
                valParamSet.add(method.validation_parameter_display)
            })
            var arr = Array.from(valParamSet)
            arr.sort((a, b) => {return this.validationParameters.indexOf(a) - this.validationParameters.indexOf(b)})
            return arr
        },
    },
    methods: {   
        saveFile: function(assesmentMethodSelected){
            console.log("assesmentMethodSelected file", this.singlefiles[assesmentMethodSelected.name])           

            if(this.singlefiles[assesmentMethodSelected.name] != null){   
                var filesAndAssesmentMethodsobject = {
                    file: this.singlefiles[assesmentMethodSelected.name],
                    assesmentMethod: assesmentMethodSelected
                }             
                this.$emit("saveFile", filesAndAssesmentMethodsobject)        
                this.singlefiles[assesmentMethodSelected.name] = null                  
            } 
            else {
                this.$toast.open({
                    message: 'Select a file to upload first',
                    type: 'is-danger',
                    position: 'is-top'
                })
            }
        },
        saveChromatogram: function(assesmentMethod){             
            if(this.dropFilesObject[assesmentMethod.name] != null && this.analyteSelections[assesmentMethod.name] != null){      
                var filesAndAssesmentMethodsobject = {
                    files: this.dropFilesObject[assesmentMethod.name],
                    assesmentMethod: assesmentMethod,
                    analyte: this.analyteSelections[assesmentMethod.name]
                }             
                this.$emit("saveChromatogram", filesAndAssesmentMethodsobject)  
                
            } else {
                this.$toast.open({
                    message: 'Select an analyte and a file to upload',
                    type: 'is-danger',
                    position: 'is-top'
                })
            }
        },
        viewData: function(assesmentMethodId){
            this.$emit("saveFile", assesmentMethodId)
        },
        deleteDropFile(index, assesmentMethodName) {
            this.dropFilesObject[assesmentMethodName].splice(index, 1)
        },
        accordionAction: function(id) {
            var accordionButton = document.getElementById(id)
            var contentOfAccordion = document.getElementById(id).nextSibling
            if (contentOfAccordion.style.display == "block") {
                contentOfAccordion.style.display = "none"
                accordionButton.classList.remove("is-primary");
            } else if (contentOfAccordion.style.display == "none") {
                contentOfAccordion.style.display = "block"
                accordionButton.classList.add("is-primary");
            } else if(contentOfAccordion.style.display == "") {
                contentOfAccordion.style.display = "block"
                accordionButton.classList.add("is-primary");
            }

            // accordionButton class
            var otherAccordions = Array.from(document.getElementsByClassName("accordionButton"))
            otherAccordions.forEach(function(otherAccordionButton){
                if(accordionButton != otherAccordionButton){
                    var content = otherAccordionButton.nextSibling
                    content.style.display = "none"
                    otherAccordionButton.classList.remove("is-primary");
                }
                
            })

        } 
    }
}
</script>

<style scoped>
.contentOfAccordion{
    display: none;
}
</style>

